/* ZP Sticky ATC (mobile PDP).
   Shows the bar whenever the theme's own add button is off screen, below it as well as above:
   at 390 px that button starts about 1.6 screens down, so a bar that waited for the buy box to
   scroll past left the first screen with no way to add (26 Oct 2026). Proxies the add
   onto the theme's real ATC button (ajax-cart flow, quantity and Seal
   selling_plan input all reused), and reports zpu_add {source:'sticky-atc'}
   on the resulting successful /cart/add.js call. */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-zp-sticky-atc]');
    if (!bar) return;

    var formId = bar.getAttribute('data-product-form');
    var form = document.getElementById(formId);
    if (!form) return;

    var realBtn = form.querySelector('[data-add-to-cart-trigger]');
    if (!realBtn) return;

    var variants = [];
    try {
      variants = JSON.parse(bar.querySelector('[data-zp-sticky-variants]').textContent);
    } catch (e) { /* meta stays static */ }

    var titleEl = bar.querySelector('[data-zp-sticky-variant-title]');
    var priceEl = bar.querySelector('[data-zp-sticky-price]');
    var planEl = bar.querySelector('[data-zp-sticky-plan]');
    var addBtn = bar.querySelector('[data-zp-sticky-add]');
    var moneyFormat = bar.getAttribute('data-money-format') || '€{{amount_with_comma_separator}}';
    var handle = bar.getAttribute('data-product-handle') || '';
    var btnOffScreen = false;
    var suppressed = false;
    var clickedAt = 0;

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function currentVariant() {
      var sel = form.querySelector('select[name="id"][data-variants], select[name="id"]');
      var id = sel ? parseInt(sel.value, 10) : (variants[0] && variants[0].id);
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
      return variants[0] || null;
    }

    function sync() {
      var v = currentVariant();
      if (!v) return;
      if (titleEl) titleEl.textContent = v.title === 'Default Title' ? '' : v.title + ' · ';
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Aggiungi al carrello' : 'Esaurito';
      }
      if (planEl) {
        var plan = form.querySelector('[name="selling_plan"]');
        planEl.hidden = !(plan && plan.value);
      }
    }

    function render() {
      var show = btnOffScreen && !suppressed;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('zp-sticky-atc-on', show);
      if (show) {
        document.body.style.setProperty('--zp-sticky-atc-h', bar.offsetHeight + 'px');
      }
    }

    // Position check on scroll (rAF-throttled). An IntersectionObserver only
    // reports transitions, which instant scroll jumps skip entirely.
    var ticking = false;
    function update() {
      ticking = false;
      var r = realBtn.getBoundingClientRect();
      btnOffScreen = r.bottom < 0 || r.top > window.innerHeight;
      render();
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    // Hide while the ajax cart drawer / mini cart is open.
    var cartEl = document.getElementById('theme-ajax-cart');
    if (cartEl && 'MutationObserver' in window) {
      new MutationObserver(function () {
        suppressed = cartEl.classList.contains('is-visible');
        bar.classList.toggle('is-suppressed', suppressed);
        render();
      }).observe(cartEl, { attributes: true, attributeFilter: ['class'] });
    }

    form.addEventListener('change', sync);
    sync();

    addBtn.addEventListener('click', function () {
      clickedAt = Date.now();
      realBtn.click();
    });

    // Attribution: the theme adds via jQuery $.ajax('/cart/add.js') — hook completion.
    if (window.jQuery) {
      window.jQuery(document).ajaxComplete(function (event, xhr, opts) {
        if (!clickedAt || Date.now() - clickedAt > 10000) return;
        if (!opts || !opts.url || opts.url.indexOf('/cart/add') === -1) return;
        clickedAt = 0;
        if (xhr.status < 200 || xhr.status >= 300) return;
        var v = currentVariant() || {};
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'zpu_add',
          source: 'sticky-atc',
          placement: 'pdp',
          handle: handle,
          variant_id: v.id,
          price: v.price ? v.price / 100 : undefined
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
